import React from 'react';
import { DataObjectOutlined, DescriptionOutlined, SportsSoccerOutlined } from '@mui/icons-material';
import { Tab, Tabs, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useLocales, useTheme } from '../../hooks';
import { AppRoutes } from '../../Routes';
import { configTestIds } from '../shared/TestsIds';

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  tab: {
    flexDirection: 'row',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
    alignItems: 'center',
    minHeight: 54,
    '& > svg': {
      margin: '0 !important'
    }
  },
  topSection: {
    padding: theme.spacing(3, 4, 0),
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`
  }
}));

function Config(): JSX.Element {
  const { classes } = useStyles();
  const { t } = useLocales();
  const { formControlColor } = useTheme();
  const location = useLocation();

  return (
    <div data-testid={configTestIds.root} className={classes.root}>
      <div className={classes.topSection}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          {t('general.cms_configuration')}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {t('general.cms_configuration_summary')}
        </Typography>
        <Tabs
          data-testid={configTestIds.tabs}
          value={location.pathname}
          indicatorColor={formControlColor}
          textColor={formControlColor}
        >
          <Tab
            className={classes.tab}
            data-testid={configTestIds.metaTab}
            label={t('app_settings.site_meta_settings')}
            icon={<DescriptionOutlined fontSize="small" />}
            to={AppRoutes.configSeo}
            value={AppRoutes.configSeo}
            component={Link}
          />
          <Tab
            className={classes.tab}
            data-testid={configTestIds.sportsTab}
            label={t('app_settings.sports')}
            icon={<SportsSoccerOutlined fontSize="small" />}
            component={Link}
            to={AppRoutes.configSports}
            value={AppRoutes.configSports}
          />
          <Tab
            className={classes.tab}
            label={t('app_settings.schemas')}
            icon={<DataObjectOutlined fontSize="small" />}
            component={Link}
            to={AppRoutes.configSchemas}
            value={AppRoutes.configSchemas}
          />
        </Tabs>
      </div>
      <Outlet />
    </div>
  );
}

export default Config;
